import { render } from "./MiscellaneousConfig.vue?vue&type=template&id=b22db848"
import script from "./MiscellaneousConfig.vue?vue&type=script&lang=js"
export * from "./MiscellaneousConfig.vue?vue&type=script&lang=js"

import exportComponent from "/usr/local/jazevue3admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__